"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = unescape;
function unescape(html = '') {
    return html
        .replace(/&quot;/g, '"')
        .replace(/&nbsp;/g, ' ')
        .replace(/&#39;/g, "'")
        .replace(/&#x3A;/g, ':')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&Tab;/g, '    ')
        .replace(/&NewLine;/g, '\n')
        .replace(/&amp;/g, '&')
        .replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi, (substring, source) => {
        const match = source.toLowerCase();
        if (match === 'colon') {
            return ':';
        }
        if (match.charAt(0) === '#') {
            return match.charAt(1) === 'x'
                ? String.fromCharCode(parseInt(match.substring(2), 16))
                : String.fromCharCode(+match.substring(1));
        }
        return substring;
    });
}
